<template>
  <div class="box-content">
    <img src="../../image/prize/bg.jpg" alt srcset class="bg" />
    <div class="count-box">
      <img src="../../image/prize/count.jpg" alt srcset />
      <span class="count">{{ userInfo.prizeCount }}</span>
    </div>

    <LuckyWheel
      ref="myLucky"
      width="330px"
      height="330px"
      :prizes="prizes"
      :blocks="blocks"
      :buttons="buttons"
      @start="startCallback"
      @end="endCallback"
      class="myLucky"
    />

    <div class="btnList">
      <van-button class="goPrize" @click="goPrizeRule">活动规则</van-button>
      <van-button class="goPrize" @click="handleRecord">中奖记录</van-button>
    </div>

    <!-- 中奖记录 -->
    <van-popup v-model="show" style="background-color: transparent">
      <div class="pop">
        <div class="pop-box">
          <img src="../../image/prize/pop.png" class="popBg" />
          <div class="table">
            <!-- <div class="table-header" v-if="recordData.length !== 0">
              <div>奖品名称</div>
              <div class="header_title2">状态</div>
              <div>中奖日期</div>
            </div>-->
            <!-- 列表展示 -->
            <div class="pop-scroll" v-if="recordData.length !== 0">
              <div v-for="(item, index) in recordData" :key="index">
                <div class="left-box">
                  <div class="text1">
                    {{ item.prizeName ? item.prizeName : "-" }}
                  </div>
                  <div class="text2">{{ item.createTime }}</div>
                </div>
                <div
                  @click="goCustomer(item)"
                  class="text3"
                  :style="{
                    background: item.rewaedStatus === 0 ? '#473a2e' : '#d3c6c6',
                  }"
                >
                  {{ item.rewaedStatus === 0 ? "去领取" : "已兑换" }}
                </div>
              </div>
            </div>
            <div v-else class="none">暂无中奖记录</div>
          </div>
          <div @click="closeBtn" class="closeBtn">关闭弹窗</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Toast, Dialog } from "vant";
import {
  selectPrizeRecords,
  addPrizeRecords,
  updateCount,
} from "@/services/prizeRecord";
// import { loginUrl } from "../../../config/index";
// import { getUrlParams } from "@/utils/getUrlParams.js";
// import { login, setPhone } from "@/services/login.js";
import { useWxCode } from "@/services/login.js";
window.addEventListener("pageshow", function(e) {
  // 通过persisted属性判断是否存在 BF Cache
  if (e.persisted) {
    location.reload();
  }
});
export default {
  data() {
    return {
      blocks: [
        {
          padding: "18px",
          // background: "#617df2",
          imgs: [
            {
              src: require("../../image/prize/ring.jpg"),
              width: "330px",
              height: "330px",
              rotate: false,
            },
          ],
        },
      ],
      prizes: [
        {
          id: 1,
          fonts: [
            {
              text: "播报器1个(免费)",
              top: "10%",
              fontColor: "#b37200",
              fontSize: "14px",
              fontWeight: 550,
            },
          ],
          imgs: [
            {
              src: require("../../image/prize/bobaoqi.jpg"),
              // width: "100px",
              height: "45px",
              top: 50,
            },
          ],
          background: "#ffeaa9",
          range: 0,
        },
        {
          id: 2,
          fonts: [
            {
              text: "100元优惠(满100元可用)",
              top: "10%",
              fontColor: "#b37200",
              fontSize: "14px",
              fontWeight: 550,
            },
          ],
          imgs: [
            {
              src: require("../../image/prize/discount.jpg"),
              // width: "100px",
              height: "45px",
              top: 50,
            },
          ],
          background: "#fff",
          range: 3,
        },
        {
          id: 3,
          fonts: [
            {
              text: "PLUS会员系统买1年送3个月",
              top: "10%",
              fontColor: "#b37200",
              fontSize: "14px",
              fontWeight: 550,
            },
          ],
          imgs: [
            {
              src: require("../../image/prize/discount.jpg"),
              // width: "100px",
              height: "45px",
              top: 50,
            },
          ],
          background: "#ffeaa9",
          range: 0,
        },
        {
          id: 4,
          fonts: [
            {
              text: "播报器30元优惠券",
              top: "10%",
              fontColor: "#b37200",
              fontSize: "14px",
              fontWeight: 550,
            },
          ],
          imgs: [
            {
              src: require("../../image/prize/bobaoqi.jpg"),
              // width: "100px",
              height: "45px",
              top: 50,
            },
          ],
          background: "#fff",
          range: 0,
        },
        {
          id: 5,
          fonts: [
            {
              text: "50元优惠券 (满50元可用)",
              top: "10%",
              fontColor: "#b37200",
              fontSize: "14px",
              fontWeight: 550,
            },
          ],
          imgs: [
            {
              src: require("../../image/prize/discount.jpg"),
              // width: "100px",
              height: "45px",
              top: 50,
            },
          ],
          background: "#ffeaa9",
          range: 0,
        },
        {
          id: 6,
          fonts: [
            {
              text: "商城会员系统300元抵扣券",
              top: "10%",
              fontColor: "#b37200",
              fontSize: "14px",
              fontWeight: 550,
            },
          ],
          imgs: [
            {
              src: require("../../image/prize/discount.jpg"),
              // width: "100px",
              height: "45px",
              top: 50,
            },
          ],
          background: "#fff",
          range: 0,
        },
      ],
      buttons: [
        {
          radius: "25%",
          pointer: false,
          // fonts: [{ text: "开始", top: "-10px" }],
          // background: "#8a9bf3",
          imgs: [
            {
              src: require("../../image/prize/btn.jpg"),
              // width: "100px",
              height: "100px",
              top: -50,
            },
          ],
        },
      ],

      /* 用户信息 */
      userInfo: {
        prizeCount: 0,
        openid: "",
      },

      /* 中奖记录信息 */
      recordData: [],
      show: false,
    };
  },

  async created() {
    /* 查询用户信息 */
    let userInfo = await useWxCode();
    if (userInfo?.code === 200) {
      this.userInfo = userInfo.data;
      // console.log('this.userInfo==============',this.userInfo)
    }
  },

  methods: {
    // 点击抽奖按钮会触发star回调
    startCallback() {
      if (this.userInfo.prizeCount <= 0) {
        Toast("抽奖次数已用完！");
        return;
      }
      // 调用抽奖组件的play方法开始游戏
      this.$refs.myLucky.play();
      // 模拟调用接口异步抽奖
      setTimeout(() => {
        // const index = 1; // 假设后端返回的中奖索引是0
        // this.$refs.myLucky.stop(index);   // 调用stop停止旋转并传递中奖索引
        this.$refs.myLucky.stop();
      }, 3000);
    },

    // 抽奖结束会触发end回调
    async endCallback(prize) {
      let result = await updateCount({
        openid: this.userInfo.openid,
      });
      // console.log("result============", result);
      if (result.code !== 200 || result.data?.prizeCount < 0) {
        Toast("抽奖次数已用完！");
        this.userInfo.prizeCount = 0;
        return;
      }
      this.userInfo.prizeCount = result.data?.prizeCount || 0;
      await addPrizeRecords({
        wxOpenid: this.userInfo.openid,
        phone: this.userInfo?.phone,
        prizeName: prize.fonts[0].text,
      });
      Dialog.confirm({
        title: `恭喜您抽中"${prize.fonts[0].text}"`,
        message: "点击中奖记录可查看详情！",
        theme: "round-button",
        showCancelButton: false,
        confirmButtonText: "我已知晓",
      });
    },
    goPrizeRule() {
      this.$router.push({
        name: "PrizeRule",
      });
    },

    async handleRecord() {
      this.show = true;
      let cecord = await selectPrizeRecords({
        wxOpenid: this.userInfo?.openid,
      });
      this.recordData = cecord.data;
    },

    closeBtn() {
      this.show = false;
    },

    goCustomer(item) {
      if (item.rewaedStatus === 1) {
        Toast("该奖品已兑换！");
        return;
      }
      this.$router.push({
        name: "Customer",
      });
    },
  },
};
</script>

<style scoped>
.box-content {
  position: relative;
  top: 0;
  width: 100%;
  max-width: 750px;
  margin: 0 auto;
  /* height: 100%;
  min-height: 100vh; */
  /* background: url(../../image/prize/bg.jpg) no-repeat center center fixed;
  background-size: cover; */
}
.box-content .bg {
  width: 100%;
  position: relative;
  top: 0;
  display: block;
}

.count-box {
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  top: 28%;
  width: 300px;
  overflow: hidden;
}
.count-box img {
  width: 100%;
}
.count {
  position: absolute;
  left: 131px;
  top: 8px;
  width: 24px;
  text-align: center;
  color: #fff;
  font-weight: 550;
  font-size: 20px;
  text-align: center;
}
.myLucky {
  margin: 0 auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 26%;
}
.btnList {
  display: flex;
  justify-content: space-around;
  position: absolute;
  bottom: 80px;
  width: 100%;
  color: #fff !important;
  opacity: 0.8;
}
.goPrize {
  width: 150px;
  box-shadow: 0 5px 10px -5px rgb(0, 0, 0);
  color: #fff !important;
  letter-spacing: 3px;
  border-radius: 20px;
}
.van-button--default {
  color: #fff;
  background-image: linear-gradient(to bottom right, #f7804d, #f14532);
  font-size: 18px;
  font-weight: 600;
  border: none;
}

/* 弹窗 */
.pop {
  position: relative;
  width: 300px;
  border-radius: 10px;
  overflow: hidden;
  background: none;
}

.pop-box {
  position: relative;
  width: 100%;
  margin: 0 auto;
}

.popBg {
  display: block;
  width: 100%;
  height: auto;
}

.table {
  position: absolute;
  top: 72px;
  width: 85%;
  left: 0;
  right: 0;
  margin: 0 auto;
  height: 225px;
  overflow: hidden;
}

.pop-scroll {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0px;
  overflow-y: auto;
}

.pop-scroll > div {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  margin: 5px auto;
  width: 85%;
  background: #fdefe3;
  color: #473a2e;
  justify-content: space-between;
  align-items: center;
  border-radius: 15px;
  padding: 5px 10px;
}

.left-box {
  width: 140px;
}
.pop-scroll > div .text1 {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  letter-spacing: 1px;
  text-overflow: ellipsis;
  margin: 5px 0;
}

.pop-scroll > div .text2 {
  font-size: 10px !important;
  color: #b4a79b;
}

.pop-scroll > div .text3 {
  font-size: 10px;
  white-space: nowrap;
  overflow: hidden;
  letter-spacing: 1px;
  color: #fff;
  border-radius: 20px;
  padding: 5px 8px;
}

.none {
  text-align: center;
  font-size: 16px;
  color: #ff4b4b;
  margin-top: 50px;
  letter-spacing: 3px;
}

.closeBtn {
  position: absolute;
  bottom: 7px;
  left: 0;
  right: 0;
  margin: 10px auto;
  width: 80px;
  background: #d1cfca;
  color: #fff;
  text-align: center;
  border-radius: 20px;
  padding: 4px;
  font-size: 10px;
  letter-spacing: 2px;
}
</style>